var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02344 0C4.02344 0 0.0234375 4 0.0234375 9C0.0234375 14 4.02344 18 9.02344 18C14.0234 18 18.0234 14 18.0234 9C18.0234 4 14.0234 0 9.02344 0ZM9.02344 16C5.12344 16 2.02344 12.9 2.02344 9C2.02344 5.1 5.12344 2 9.02344 2C12.9234 2 16.0234 5.1 16.0234 9C16.0234 12.9 12.9234 16 9.02344 16ZM5.02344 8V10H13.0234V8H5.02344Z",
    fill: "#5282F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove-icon.0630441bee7d5ccf9ea997c50dee1a85.svg";
export { ForwardRef as ReactComponent };